/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const campaignInterviewSettingsResponseSchema = z.object({
	interviewDurationMinutes: z.number().nullable(),
	interviewBookingWindowDays: z.number().nullable(),
	interviewTokenExpiryDays: z.number().nullable(),
	interviewMeetingLocationType: z.string().nullable(),
	interviewMeetingLocationDetails: z.string().nullable(),
	interviewDescription: z.string().nullable(),
	interviewBookedStageId: z.string().nullable(),
	interviewBookedStageType: z.string().nullable(),
})

export type CampaignInterviewSettingsResponseSchema = z.infer<typeof campaignInterviewSettingsResponseSchema>
